<template>
  <div class="pag_faq" v-if="listItems.length > 0">
    <div class="faq">
      <template  v-for="(item, idx) in listItems">
        <div class="row grupo_faq" v-if="item.questoes.length > 0">
          <div class="small-12 medium-3 large-3 columns">
            <p class="grupo_title">
              {{ item.tema }}
            </p>
          </div>
          <div class="small-12 medium-9 large-9 columns">
            <Accordion 
              class="faqacc"
              :idx="idx"
              :questoes="item.questoes" />
            <div class="buttonwrapper" 
              v-if="item.currentIndex < item.questoes.length">
              <a @click="loadMoreFaq(idx)"
                class="button goto_site azul_site_border azul_site_color"
                target="_blank">
                {{ $t("vermais") }}
              </a>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
  
<script>
import { ref } from 'vue';
import axios from "@/axios.js";
import Accordion from '@/components/accordion.vue';
import { i18n } from '@/main.js';


export default {
  components:{
    Accordion
  },
  setup(){

    const listItems = ref([]);
    const lang = i18n.global.locale;

    const loadMoreFaq = () => {

    }
    
    const sortFaqPorTema = (list) => {
      axios.get(`/faq/temas?idioma=${lang}&unidadeId=${import.meta.env.VITE_UID}`)
        .then(data => {
          listItems.value = data.data.map(tema => {
            const questionList = list
                .filter(question => question.docfaq_tema === tema.url)
                .map(question => ({ ...question, Id: question.ID, visible: true }));
            return {
                tema: tema.Title,
                questoes: questionList,
                currentIndex: questionList.length
            };
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
    
    const fetchFaq = () => {
      axios.get(`/faq?unidadeId=${import.meta.env.VITE_UID}&idioma=`+lang)
        .then(data => {
          sortFaqPorTema(data.data.data)
        })
        .catch(error => {
          console.log(error);
        });
    }

    fetchFaq()

    return {
      listItems,
      loadMoreFaq
    }
  }
}


</script>

<style scoped>
.faq {
    padding-top: 5px;
    padding-bottom: 80px;
}
.grupo_faq {
    border-top: 1px solid #a7a5a5;
}
.grupo_faq .columns {
    padding-right: 0px;
}
.grupo_title {
    font-family: "Montserrat Bold";
    font-size: 18px;
    padding-top: 10px;
    color: #878b8c;
    text-transform: uppercase;
}

@media (max-width: 676px) {

  .faqacc{
    background-color: transparent;
  }

  .grupo_faq {
    border-top: transparent;
  }

  .faq {
    padding-bottom: 5px;
  }

  .grupo_faq .columns {
    padding-left: 0;
  }

  .grupo_title {
    font-size: 10px;
    margin-bottom: 8px;
    font-family: Montserrat;
    text-transform: uppercase;
    color: #707475;
  }
}



</style>
  